import React, { useState, useEffect } from 'react';
import type { StepId } from '../../types';

export interface JourneyItem {
  stepId: StepId;
  label: string;
  index: number;
  isCurrent: boolean;
  canJump: boolean;
}

interface WizardStepHistoryProps {
  journeyItems: JourneyItem[];
  currentStepId: StepId;
  onStepClick: (stepId: StepId) => void;
}

export const WizardStepHistory: React.FC<WizardStepHistoryProps> = ({
  journeyItems,
  currentStepId,
  onStepClick,
}) => {
  const [isOverviewOpen, setIsOverviewOpen] = useState(false);

  // Close overview when step changes
  useEffect(() => {
    setIsOverviewOpen(false);
  }, [currentStepId]);

  if (journeyItems.length <= 1) {
    return null;
  }

  return (
    <div className="wizard-history">
      <button
        type="button"
        className="wizard-history__toggle"
        onClick={() => setIsOverviewOpen((prev) => !prev)}
        aria-expanded={isOverviewOpen}
        aria-controls="wizard-step-overview"
      >
        {isOverviewOpen ? 'Skjul trin' : 'Se trin'}
      </button>

      <div
        id="wizard-step-overview"
        className="wizard-history__panel"
        hidden={!isOverviewOpen}
      >
        <ol className="wizard-history__list">
          {journeyItems.map((item) => (
            <li key={item.stepId} className="wizard-history__item">
              <button
                type="button"
                className={`wizard-history__step${item.isCurrent ? ' wizard-history__step--current' : item.canJump ? ' wizard-history__step--past' : ''}`}
                onClick={() => item.canJump && onStepClick(item.stepId)}
                disabled={!item.canJump}
                aria-current={item.isCurrent ? 'step' : undefined}
              >
                <span className="wizard-history__index" aria-hidden="true">
                  {item.index + 1}
                </span>
                <span className="wizard-history__label">{item.label}</span>
              </button>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};
